import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/style.scss";
import App from "./App";
import { AuthProvider, UserProvider } from "./contexts";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AuthProvider>
        <UserProvider>
            <App />
        </UserProvider>
    </AuthProvider>,
);
